import { Entity, Column, PrimaryGeneratedColumn, Check, ManyToOne, JoinColumn } from 'typeorm'
import RespondentSession from './RespondentSession'

export enum RespondentSessionState {
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete',
  INVALID_VENDOR_DEMOGRAPHICS = 'invalid_vendor_demographics',
  RED_FLAG = 'red_flag'
}

export enum SurveyToolRedFlag {
  NOT_QUALIFY = 'not_qualify',
  SPEEDER = 'speeder',
  PASTER = 'paster',
  BLACKLIST_IP = 'blacklist_ip',
  SPAM = 'spam',
  NOT_ENOUGH_ANSWERS = 'not_enough_answers',
  AGE_CHECK_FAIL = 'age_check_fail',
  OPT_OUT_MOBILE = 'opt_out_mobile',
  HERRING_FAIL = 'herring_fail',
  REDIRECTED_TO_FF = 'redirected_to_FF',
  SEEN_BEFORE = 'seen_before',
  NO_AUDIO = 'no_audio',
  MALFORMED_ANSWER = 'malformed_answer',
  SC_HIGH_THREAT_POTENTIAL = 'sc_high_threat_potential'
}

@Entity('respondent_session_events')
@Check(`CASE WHEN (state = 'red_flag') THEN red_flag IS NOT NULL ELSE TRUE END`)
export default class RespondentSessionEvent {
  @PrimaryGeneratedColumn('increment')
  id!: number

  @Column({ name: 'created_at' })
  createdAt!: Date

  @ManyToOne(type => RespondentSession, r => r.respondentSessionEvents)
  @JoinColumn({ name: 'respondent_session_id' })
  respondentSession!: RespondentSession

  @Column({
    name: 'state',
    type: 'enum',
    enum: RespondentSessionState
  })
  respondentSessionState!: RespondentSessionState

  @Column({
    name: 'red_flag',
    type: 'enum',
    enum: SurveyToolRedFlag
  })
  redFlag?: SurveyToolRedFlag
}
